import { JobsActionTypes, JobsState, READ_JOBS_DATA_REQUEST, READ_JOBS_DATA_SUCCESS, READ_JOBS_DATA_FAILURE } from "store/reducers/types/dashboard/jobs";

const defaultState: JobsState = {
  isLoading: false,
  errorMessage: ""
};

export default function jobs(state = defaultState, action: JobsActionTypes): JobsState {
  switch (action.type) {
    case READ_JOBS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_JOBS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_JOBS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
